// Common Sydney region/district labels used for the branches.region field.
// Rendered through a <datalist> so the admin can also free-type if a
// branch sits in a region we haven't pre-listed.
const SYDNEY_REGIONS = [
  "CBD / Sydney City",
  "Eastern Suburbs",
  "Inner West",
  "Lower North Shore",
  "Upper North Shore",
  "Northern Beaches",
  "Northern Sydney",
  "The Hills District",
  "Western Sydney",
  "South-Western Sydney",
  "Sutherland Shire",
  "St George",
  "Macarthur",
  "Hawkesbury",
  "Central Coast",
];

export default SYDNEY_REGIONS;
